import axios from "axios";
import * as actionType from "../../../constant/actionType";
// import { fetchData,fetchDataSuccess, fetchDataError } from "../../redux/classes/client-portal/clientCsvSlice";
export const AdminRaiseClientInvoice = (APIData) => async (dispatch) => {
  const response = await axios({
    method: "post",
    data: APIData,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("conserve_authtoken")}`,
    },
    url: `${actionType.environment_url}/api/admin/client/AdminRaiseClientInvoice`,
  });
  return response.data;
  // dispatch(fetchDataSuccess());
};
